import { useDidMount } from "utils/customHooks"

function toggleClassOnHover(node: HTMLElement | null, className: string) {
    function onMouseOver() {
        node?.classList.add(className)
    }
    function onMouseOut() {
        node?.classList.remove(className)
    }
    node?.addEventListener("mouseover", onMouseOver)
    node?.addEventListener("mouseout", onMouseOut)
    return function removeHandlers() {
        node?.removeEventListener("mouseover", onMouseOver)
        node?.removeEventListener("mouseout", onMouseOut)
    }
}

export function useToggleClassOnHover(getNode: () => HTMLElement | null, className: string) {
    useDidMount(() => toggleClassOnHover(getNode(), className))
}
